// extracted by mini-css-extract-plugin
export var bulletActiveClass = "swiperText-module--bulletActiveClass--1ORMg";
export var bulletClass = "swiperText-module--bulletClass--rZmDq";
export var desc = "swiperText-module--desc--J0X6g";
export var head = "swiperText-module--head--eAaa3";
export var swiperText = "swiperText-module--swiperText--+f-lh";